import { render, staticRenderFns } from "./OtherEvents.vue?vue&type=template&id=50048a85"
import script from "./OtherEvents.vue?vue&type=script&lang=js"
export * from "./OtherEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports